export type FundedStatusChipColor = 'success' | 'warning' | 'error' | 'default'

export type FundedStatusDisplay = {
  label: string
  chipColor: FundedStatusChipColor
}

/** Yellow after 14 days; red after 21 days (see #957). */
export function getFundedChipColorForDaysSinceFunded(daysSinceFunded: number): FundedStatusChipColor {
  if (daysSinceFunded <= 14) return 'success'
  if (daysSinceFunded <= 21) return 'warning'
  return 'error'
}

/**
 * Chip label/color for vehicle funded status (uses existing `funded` / `funded_date` fields).
 */
export function getFundedStatusDisplay(
  vehicle: { funded?: boolean | null; funded_date?: string | null } | null | undefined
): FundedStatusDisplay {
  const isFunded = Boolean(vehicle?.funded)
  if (!isFunded) return { label: 'Not funded', chipColor: 'default' }

  const fundedDate = vehicle?.funded_date
  if (!fundedDate) return { label: 'Funded', chipColor: 'success' }

  const fundedMs = new Date(fundedDate).getTime()
  if (Number.isNaN(fundedMs)) return { label: 'Funded', chipColor: 'success' }

  const daysSinceFunded = Math.floor(Math.max(0, Date.now() - fundedMs) / (24 * 60 * 60 * 1000))
  return {
    label: `Funded (${daysSinceFunded.toLocaleString('en-US')} day${daysSinceFunded === 1 ? '' : 's'})`,
    chipColor: getFundedChipColorForDaysSinceFunded(daysSinceFunded),
  }
}
